import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { transitions } from '@/css/resources/variables.css';
import {
	fluidValues,
	fontStyle,
	fluidPadding,
	fluidMargin,
	fluidBorderWidth,
	fluidBorderRadius,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidValues(
			'minWidth',
			styles?.minWidth?.[0],
			styles?.minWidth?.[1],
			true
		),
		fluidPadding(styles?.padding),
		fontStyle(
			{
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			},
			false
		),
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			background: styles?.backgroundColor,
			borderColor: styles?.border?.color,

			'.supt-button__inner': fluidMargin(styles?.margin),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		display: 'block',
		width: 'max-content',
		textDecoration: 'none',
		userSelect: 'none',
		transition: `all ${transitions.fast} ease-out`,
		textAlign: 'center',
		borderStyle: 'solid',
		marginBottom: 0,
		padding: 0,

		'.supt-button__inner': {
			display: 'block',
		},

		'&:hover, &:focus-within': getDynamicStyles(styles?.states?.hover),
	});

// edit
const getEditStyles = (styles) =>
	css(fluidMargin(styles?.margin), {
		display: 'flex',
		alignItems: 'center',

		'.components-toolbar.is-position-left': {
			order: -1,
			marginRight: '10px',
		},
		'.components-toolbar.is-position-right': {
			order: 0,
			marginLeft: '5px',
		},
		'.components-button.has-icon .dashicon': {
			marginLeft: 0,
			marginRight: 0,
		},
		'.supt-buttonAnchor': {
			marginTop: 0,
		},

		'.block-editor-plain-text': {
			background: 'none',
			padding: 0,
			height: 'auto !important',
			display: 'block',
			textTransform: 'inherit',
			letterSpacing: 'inherit',
			textAlign: 'center',
			overflow: 'hidden !important' /* hide the scrollbar */,
		},
	});

export { getStyles, getEditStyles };
